import { render, staticRenderFns } from "./comp_SkuChip.vue?vue&type=template&id=0082d78d&"
import script from "./comp_SkuChip.vue?vue&type=script&lang=js&"
export * from "./comp_SkuChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports